var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitApp = function SvgGitApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.44 63"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.44,
    y: 10,
    width: 53,
    height: 53,
    rx: 8.1,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.88,53.38c3.07,0,5.55-2.49,5.55-5.55s-2.49-5.55-5.55-5.55-5.55,2.49-5.55,5.55,2.49,5.55,5.55,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.55,14.5c3.07,0,5.55-2.49,5.55-5.55s-2.49-5.55-5.55-5.55-5.55,2.49-5.55,5.55,2.49,5.55,5.55,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.55,53.38c3.07,0,5.55-2.49,5.55-5.55s-2.49-5.55-5.55-5.55-5.55,2.49-5.55,5.55,2.49,5.55,5.55,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.55,14.5v27.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.88,42.27V14.5s0-5.55-5.55-5.55h-8.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.55,15.89l-6.94-6.94,6.94-6.94"
  }))));
};
export default SvgGitApp;